<script setup>
// The pass comparison beside Count me in (AppGatePrice, D23 point 3):
// "Wednesday Mixer pass: £40 · Covers tonight and the other 7 sessions left in
// this block, which would be £64 at £8 each. Then £60 every 12 weeks." with
// Get the pass. The numbers come from useMembershipGates().meetPassOffer (A3's
// seam); nothing renders for null.
import {computed} from 'vue';
import {money} from '~/utils/membershipsMember';

const props = defineProps({
  offer: {type: Object, default: null},
  /** Where Get the pass comes back to. */
  returnTo: {type: String, default: null},
});

const title = computed(() => props.offer ? `${props.offer.typeName}: ${money(props.offer.priceNowMinor, props.offer.currency)}` : '');
const line = computed(() => {
  const o = props.offer;
  if (!o) return '';
  if (o.line) return o.line;
  const others = Math.max(0, (o.sessionsLeft ?? 1) - 1);
  const each = money(o.perSessionMinor, o.currency);
  const all = money((o.sessionsLeft ?? 0) * (o.perSessionMinor ?? 0), o.currency);
  return others > 0
      ? `Covers this session and the other ${others} left in this block, which would be ${all} at ${each} each.`
      : `Covers this session.`;
});
const to = computed(() => props.offer ? ({
  name: 'ClubMembershipJoin',
  params: {clubId: props.offer.clubId, typeId: props.offer.typeId},
  query: props.returnTo ? {returnTo: props.returnTo} : {},
}) : null);
</script>

<template>
  <div v-if="offer" class="mpo" data-testid="meet-pass-offer">
    <div class="mpo-ic"><v-icon size="18" icon="mdi-ticket-confirmation-outline"/></div>
    <div class="flex-fill">
      <div class="mpo-title">{{ title }}</div>
      <div class="mpo-sub">{{ line }}<template v-if="offer.thenLine">{{ ' ' }}{{ offer.thenLine }}</template></div>
    </div>
    <v-btn color="success" variant="tonal" rounded="pill" size="small" :to="to">Get the pass</v-btn>
  </div>
</template>

<style scoped lang="scss">
.mpo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 12px;
  background: rgb(var(--v-theme-successTint));
  margin-top: 8px;
}
.mpo-ic {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-success));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mpo-title { font-size: 13px; font-weight: 700; }
.mpo-sub { font-size: 12px; color: rgb(var(--v-theme-textSubtle)); line-height: 1.45; }
</style>
